export default "__VITE_ASSET__JWdO7uOe__"